/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import App from './App/index'
import AppointmentDates from './AppointmentDates/index'
import AppointmentTypes from './AppointmentTypes/index'
import Location from './Location/index'
import MedicalForm from './MedicalForm/index'
import OptInMessages from './OptInMessages/index'
import ProgressBar from './ProgressBar/index'
import React from 'react'
import SaveAction from './SaveAction/index'
import Theme from './Theme/index'
import TysiaCard from 'DesignSystem/TysiaCard/index'
import TysiaCardContent from 'DesignSystem/TysiaCard/TysiaCardContent/index'
import TysiaHeading from 'DesignSystem/TysiaHeading/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import TysiaToggle from 'DesignSystem/TysiaToggle/index'
import TysiaToggleButton from 'DesignSystem/TysiaToggle/TysiaToggleButton/index'
import TysiaToggleText from 'DesignSystem/TysiaToggle/TysiaToggleText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Settings/Content/Leads/Content/Content/Settings/Content",
  onChange
  
}) {
let dtSpaceL = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.l'
        })
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtColorsNeutral500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.500'
        })
let settingsMedicaidEnabledValueData = fromData.useDataValue({ viewPath,
context: 'settings',
path: 'medicaidEnabled',
})
let settingsMedicaidEnabledChangeData = fromData.useDataChange({ viewPath,
context: 'settings',
path: 'medicaidEnabled',
})
  return (<React.Fragment
>
<div
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 style={{'--pb-1-Z1Yf8zk': typeof dtSpaceL === 'number' ? `${dtSpaceL}px` : dtSpaceL}}
 className={`views-block ${styles.Vertical}`}
>
<TysiaHeading
  viewPath={`${viewPath}/TysiaHeading`}
 marginTop={dtSpaceS}
 level="h4"
 text="Design"
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="medium"
 marginTop={dtSpaceXs}
 color={dtColorsNeutral500}
 text="Choose from predefined themes or design your custom theme"
/>
<TysiaCard
  viewPath={`${viewPath}/TysiaCard`}
 size="xlarge"
 marginTop={dtSpaceS}
 flexGrow={1}
 flexShrink={1}
 flexBasis="100%"
>
{childProps => (
<TysiaCardContent
{...childProps}
  viewPath={`${viewPath}/TysiaCardContent`}
 paddingTop={0}
>
{childProps => (
<div
  data-testid="Content.Vertical:1"
  data-view-path={viewPath}
 className="views-block"
>
<Theme
  viewPath={`${viewPath}/Theme`}
/>
<ProgressBar
  viewPath={`${viewPath}/ProgressBar`}
/>
</div>
)}
</TysiaCardContent>
)}
</TysiaCard>
<TysiaHeading
  viewPath={`${viewPath}/TysiaHeading`}
 marginTop={dtSpaceS}
 level="h4"
 text="Appointment configuration"
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="medium"
 marginTop={dtSpaceXs}
 color={dtColorsNeutral500}
 text="Settings when scheduling appointments with the app"
/>
<TysiaCard
  viewPath={`${viewPath}/TysiaCard`}
 size="xlarge"
 marginTop={dtSpaceS}
 flexGrow={1}
 flexShrink={1}
 flexBasis="100%"
>
{childProps => (
<TysiaCardContent
{...childProps}
  viewPath={`${viewPath}/TysiaCardContent`}
 paddingTop={0}
>
{childProps => (
<div
  data-testid="Content.Vertical:2"
  data-view-path={viewPath}
 className="views-block"
>
<Location
  viewPath={`${viewPath}/Location`}
/>
<AppointmentTypes
  viewPath={`${viewPath}/AppointmentTypes`}
/>
<TysiaToggle
  viewPath={`${viewPath}/TysiaToggle`}
 justifyContent="flex-start"
 marginTop={dtSpaceS}
 data="settings.medicaidEnabled"
 value={settingsMedicaidEnabledValueData}
 onChange={settingsMedicaidEnabledChangeData}
>
{childProps => (
<React.Fragment>
<TysiaToggleButton
{...childProps}
  viewPath={`${viewPath}/TysiaToggleButton`}
 paddingTop={0}
 paddingBottom={0}
 paddingRight={0}
 paddingLeft={0}
/>
<TysiaToggleText
{...childProps}
  viewPath={`${viewPath}/TysiaToggleText`}
 marginLeft={dtSpaceXs}
 text="Accept Medicaid"
/>
</React.Fragment>
)}
</TysiaToggle>
<MedicalForm
  viewPath={`${viewPath}/MedicalForm`}
/>
<AppointmentDates
  viewPath={`${viewPath}/AppointmentDates`}
/>
</div>
)}
</TysiaCardContent>
)}
</TysiaCard>
<TysiaHeading
  viewPath={`${viewPath}/TysiaHeading`}
 marginTop={dtSpaceS}
 level="h4"
 text="General Settings"
/>
<TysiaCard
  viewPath={`${viewPath}/TysiaCard`}
 size="xlarge"
 marginTop={dtSpaceS}
 flexGrow={1}
 flexShrink={1}
 flexBasis="100%"
>
{childProps => (
<TysiaCardContent
{...childProps}
  viewPath={`${viewPath}/TysiaCardContent`}
 paddingTop={0}
>
{childProps => (
<div
  data-testid="Content.Vertical:3"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical1}`}
>
<OptInMessages
  viewPath={`${viewPath}/OptInMessages`}
/>
<App
  viewPath={`${viewPath}/App`}
/>
</div>
)}
</TysiaCardContent>
)}
</TysiaCard>
<SaveAction
  viewPath={`${viewPath}/SaveAction`}
/>
</div>
{children}
</React.Fragment>)
}